/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@lib/api-client';
import { ApiResponse } from 'shared/interfaces/project';

export const getAdditionalities =
	(): Promise<ApiResponse> => {
		return apiClient.get('/additionalities', {
			params: {
				pageSize: 100,
			},
		});
	};

export const useAdditionalities = () => {
	const { data, isFetching, isFetched } = useQuery({
		queryKey: ['additionalities'],
		queryFn: () => getAdditionalities(),
	});

	const updateList = (productions: any) =>
		productions.reduce((acc: any, currentItem: any) => {
			const modifiedItem = {
				...currentItem,
			};
			acc.push(modifiedItem);

			return acc;
		}, []);

	return {
		data: data ? updateList(data?.rows) : [],
		isLoading: isFetching && !isFetched,
		isFetched,
		total: data?.total,
		page: data?.page,
		pageSize: data?.pageSize,
		totalPages: data?.totalPages,
	};
};
